<ngx-spinner></ngx-spinner>
<div class="row">
    <div class="col-lg-4 first-section">
<a [href]="logoLink" target="_blank"><div class="logo"></div></a>
<form [formGroup]="logInForm">
   <h4 class="text-center my-2">Welcome Back</h4>
   <span class="text-center d-block" *ngIf="signInError"> *Please enter Valid credentials to sign in</span>
   <div class="first-input">
<label>Email</label>
<input type="text" class="" placeholder="Enter email...." formControlName="username">
<span class="text-end d-block" *ngIf="logInForm.get('username').invalid&&logInForm.get('username').touched"> *Incorrect Email</span>

</div>
<div class="sec-input">
<label>Password</label>
<input type="password" class="" placeholder="Enter Password...." formControlName="password" id="pass">
<span class="text-end d-block" *ngIf="logInForm.get('password').invalid&&logInForm.get('password').touched"> *Incorrect Password</span>

<div id="toggle"><img [src]="toggleImg" (click)="TogglePassword()"></div>
<button class="btn" (click)="signIn()" [disabled]="logInForm.invalid">Sign In</button>
</div>
</form>
<p class="fw-bold">© Copyrights MAVEN Developments {{currentYear}} All rights reserved. Made with Nuts by<span class="nuts"><a href="https://socialnuts-eg.com/#/" target="_blank"> Social Nuts</a></span></p>
</div>

<div class="col-lg-8 background-img">

    </div>

  </div>
